import Vue from "vue";
import Vuex from "vuex";
import * as auth from "@/util/auth";
import energy from "./modules/energy/index";
import warnLog from './modules/warnLog'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 用户信息（token refresh_token）
    user: auth.getUser(),
    allId: null,
    airdetail: {
      changed: false,
      status: 0,
      modeControl: null,
      tempControl: null
    },

    // 返回时携带参数,非组件之间
    infosafely: {
      tag: false,
      index: "",
      status: null,
      remark: ""
    }
  },
  // 获取
  getters: {
    getinfosafely(state) {
      return state.infosafely;
    }
  },
  // 修改值
  mutations: {
    changesafely(state, payload) {
      state.infosafely = { ...state.infosafely, ...payload };
    },
    changeAirdetail(state, payload) {
      state.airdetail = payload;
    },
    changeTenantId(state, key) {
      state.tenantId = key;
      window.localStorage.setItem("tenantId", state.tenantId);
    },
    setPrint(state, all) {
      // 设置参数
      state.allId = all;
    },
    // 存储用户信息
    setUser(state, user) {
      // 更新state的状态
      state.user = user;
      // 更新本地存储
      auth.setUser(user);
    },
    // 清除用户信息
    delUser(state) {
      // 更新state的状态
      state.user = {};
      // 更新本地存储
      auth.delUser();
    }
  },
  actions: {},
  modules: {
    energy,warnLog
  }
});
